import { render, staticRenderFns } from "./storage_distribution_list.vue?vue&type=template&id=9e74b060"
import script from "./storage_distribution_list.vue?vue&type=script&lang=js"
export * from "./storage_distribution_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports